import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import "../../../styles/admin.css";
import api from "../../../config/URL";
import Withdraw from "./Withdraw";

function UserWalletsView({ handleLogout }) {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`affiliate/affiliate-user`);
      setData(response.data.data);
    } catch (error) {
      toast.error("Error Fetching Data ", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [id]);

  const stripHtmlTags = (html) => {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  return (
    <section className="px-4">
      {loading ? (
        <div className="loader-container">
          <div className="loader">
            <svg viewBox="0 0 80 80">
              <circle cx="40" cy="40" r="32"></circle>
            </svg>
          </div>
        </div>
      ) : (
        <>
          <div className="card shadow border-0 mb-3">
            <div className="row p-3">
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <h3 className="ls-tight">Affiliate Details</h3>
                </div>
                <Withdraw handleLogout={handleLogout} />
              </div>
            </div>
          </div>
          <div
            className="container card shadow border-0"
            style={{ minHeight: "80vh" }}
          >
            <div className="row mt-5 p-3">
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Name</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.name || "-"}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Email</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.email || "-"}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Affiliate Code</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_account?.affiliate_code || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Affiliate Percentage</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_account?.affiliate_percentage || "0"}%
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Affiliate Terms</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      :{" "}
                      {stripHtmlTags(
                        data?.affiliate_account?.affiliate_terms || "-"
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Account Holder</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_account?.account_holder_name || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Bank Name</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_account?.bank_name || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Account Number</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_account?.account_number || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">IFSC Code</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_account?.ifsc_code || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Bank Name</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_account?.bank_name || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Total Commission Earned</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : ₹{" "}
                      {data?.affiliate_account?.total_commission_earned || "0"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Total Withdrawn</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : ₹ {data?.affiliate_account?.total_withdrawn || "0"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Minimum Withdrawn</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : ₹ {data?.affiliate_account?.minimum_withdrawal || "0"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">OutStanding Balance</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : ₹ {data?.affiliate_account?.outstanding_balance || "0"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
}

export default UserWalletsView;
